import { createContext, useContext } from "react";
import type { User } from "../../api/types";

// 登入狀態的唯一來源。以 GET /api/auth/me 判定 —— 前端不自己記「我登入過」,
// 因為真正說了算的是後端那顆 session cookie,它可能在任何一刻過期。

export type AuthStatus = "loading" | "authenticated" | "anonymous";

export interface AuthState {
  /** loading:還在問後端「我是誰」,這段期間不可以妄下判斷把人踢去登入頁。 */
  status: AuthStatus;
  user: User | null;
  /** 失敗時丟出 ApiError,訊息即後端原句,交給登入表單顯示。 */
  login: (email: string, password: string, remember?: boolean) => Promise<void>;
  logout: () => Promise<void>;
  /** 重新問一次 /auth/me。改完自己的姓名或 Email 之後用,側邊欄才不會還是舊的。 */
  refresh?: () => Promise<void>;
}

/**
 * 沒有 Provider 時的預設值:視同未登入。
 *
 * AppShell 與 Sidebar 是純外框,測試會單獨 render 它們而不套 Provider;
 * 讓 useAuth 在那種情況丟例外,等於逼每個外框測試都要假造一份登入狀態。
 * 預設「未登入」則只是不顯示登出區塊,畫面仍然正確。
 */
export const ANONYMOUS: AuthState = {
  status: "anonymous",
  user: null,
  login: async () => {
    throw new Error("AuthProvider 尚未掛載");
  },
  logout: async () => {},
};

export const AuthContext = createContext<AuthState>(ANONYMOUS);

export function useAuth(): AuthState {
  return useContext(AuthContext);
}
